export const API_BASE_URL = import.meta.env.VITE_API_SERVICE_URI ?? '';
// Derived root — strips the /api-service suffix so sibling services work
export const API_ROOT_URL = API_BASE_URL.replace(/\/api-service\/?$/, '');
export const OLD_FRONTEND_URL =
  import.meta.env.VITE_OLD_FRONTEND_URL ?? 'http://localhost:3500';
export const BACKEND_URL = import.meta.env.VITE_BACKEND_URI ?? '';
export const RISK_ANALYSIS_URL =
  import.meta.env.VITE_RISK_ANALYSIS_SERVICE_URI ?? API_BASE_URL;
export const AUDITS_SERVICE_URL =
  import.meta.env.VITE_AUDITS_SERVICE_URI ?? API_BASE_URL;
export const CASCADE_MAP_SERVICE_URL =
  import.meta.env.VITE_CASCADE_MAP_SERVICE_URI ?? API_BASE_URL;
/**
 * Base for certified-materials calls. The env var still points at the standalone
 * CMM service in staging/production; flipping it to `<root>/api/certified-materials`
 * is the cutover. Where it is unset (local dev) the platform routes are the
 * default — `API_BASE_URL` would resolve to `/api-service`, which serves neither.
 */
// `||`, not `??`: a *blank* value in a Render env group would otherwise resolve
// the base to `''` and send every call to a relative path. Clearing the field
// instead of deleting the row is the likely mistake during the cutover, so blank
// falls back to the platform routes exactly like unset.
export const CERTIFIED_MATERIALS_SERVICE_URL =
  import.meta.env.VITE_CERTIFIED_MATERIALS_SERVICE_URI ||
  `${API_ROOT_URL}/api/certified-materials`;
/**
 * CMM_COMPAT: true when the base above resolves to platform's routes rather than
 * the standalone CMM service, whose responses are not enveloped. Derived from the
 * resolved URL, so the one cutover lever moves the host and the response shape
 * together. Removal recipe: `src/api/certified-materials/compat.ts`.
 */
export const CERTIFIED_MATERIALS_ON_PLATFORM =
  /\/api\/certified-materials\/?$/.test(CERTIFIED_MATERIALS_SERVICE_URL);
/**
 * Base of the retired `supplier-questionnaire-service`.
 *
 * **No production call site uses this any more** — every questionnaire endpoint
 * moved to `BACKEND_URL`/`API_ROOT_URL`, and the backend service it pointed at
 * has been deleted. It survives on purpose: `saveBuilderDetail.test.ts` and
 * `deleteQuestionnaireTemplates.test.ts` assert `base).not.toBe(
 * QUESTIONNAIRE_SERVICE_URL)`, which is a stronger guard than comparing against
 * an inlined string — it stays correct if the old base is ever redefined. Delete
 * it only together with those two assertions.
 */
export const QUESTIONNAIRE_SERVICE_URL =
  import.meta.env.VITE_QUESTIONNAIRE_SERVICE_URI ??
  `${API_ROOT_URL}/supplier-questionnaire-service`;
/** Base URL for new-style cascade-tracing routes (registered under /api/). */
export const CASCADE_TRACING_API_URL =
  import.meta.env.VITE_CASCADE_TRACING_API_URI ?? `${API_ROOT_URL}/api`;

export const MAPBOX_PUBLIC_TOKEN =
  (import.meta.env.VITE_MAPBOX_PUBLIC_TOKEN as string | undefined) ?? '';
/** CDN URL for the retraced shop-components loader script (registers the
 *  `<retraced-cards>`, `<retraced-icons>`, etc. custom elements). Used by
 *  the DPP webshop-preview tab. Empty when unset — preview falls back to
 *  raw custom-element DOM without the loader bundle. */
export const SHOP_COMPONENT_LOADER_URL =
  (import.meta.env.VITE_SHOP_COMPONENT_LOADER_URI as string | undefined) ?? '';
